import React, { useEffect, useRef } from 'react';

import styles from './index.module.scss';
import { Field } from '../index';
import { pushGtmEvent } from '../../../../utils/gtm';

type Props = {
  disabled?: boolean;
  label?: string;
  name: string;
  min?: number;
  max?: number;
  step?: number;
};

const RangeField = ({ label = '', name, ...props }: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  const onChange = (e: Event) => {
    const target = e.target as HTMLInputElement;
    if (target) {
      target.style.setProperty('--value', target.value);
    }
  };

  // Usual "Click" event doesn't work for range field on mobile
  // devices, "touchstart" should be used instead to catch
  // the interaction with this component.
  const onTouchStart = (e: Event) => {
    const target = e.target as HTMLInputElement;
    if (target) {
      pushGtmEvent({
        event: 'gtm.touchstart',
        touchstartTarget: target.tagName,
      });
    }
  };

  useEffect(() => {
    const e = ref.current;

    if (!e) {
      return;
    }

    e.style.setProperty('--value', e.value);
    e.style.setProperty('--min', e.min === '' ? '0' : e.min);
    e.style.setProperty('--max', e.max === '' ? '100' : e.max);

    e.addEventListener('input', onChange);
    e.addEventListener('touchstart', onTouchStart);

    return () => {
      if (e) {
        e.removeEventListener('input', onChange);
        e.removeEventListener('touchstart', onTouchStart);
      }
    };
  }, []);

  return (
    <div className={styles['slider-field']}>
      <label htmlFor={`slider-${name}`} data-component={'label-range-field'}>
        <span>{label}</span>
        <Field
          name={name}
          id={`slider-${name}`}
          component="input"
          type="range"
          aria-label={label}
          data-component={'range-field'}
          ref={ref}
          {...props}
        />
      </label>
    </div>
  );
};

export default RangeField;
